<div>
  <header class="fixed-menu" *ngIf="!isLogin && !shoulHideMenu() && !proposalLoginMenu() ">
    <app-navbar></app-navbar>
  </header>

  <div>
    <router-outlet></router-outlet>
  </div>
</div>
<app-loader></app-loader>
<app-footer></app-footer>